import { jsx as e } from "react/jsx-runtime";
import t from "react";
const i = t.memo(({
  width: a = 16,
  color: l = "#D42F42",
  height: o = 17
}) => /* @__PURE__ */ e("svg", { fill: "none", height: o, viewBox: "0 0 17 16", width: a, children: /* @__PURE__ */ e("path", { clipRule: "evenodd", d: "M6 2.25a.75.75 0 0 0-.75.75v1.25H2.5a.75.75 0 0 0 0 1.5h11a.75.75 0 0 0 0-1.5h-2.75V3a.75.75 0 0 0-.75-.75H6Zm3.25 2v-.5h-2.5v.5h2.5ZM4 6.25a.75.75 0 0 1 .75.75v6a.25.25 0 0 0 .25.25h6a.25.25 0 0 0 .25-.25V7a.75.75 0 0 1 1.5 0v6A1.75 1.75 0 0 1 11 14.75H5A1.75 1.75 0 0 1 3.25 13V7A.75.75 0 0 1 4 6.25Z", fill: l, fillRule: "evenodd" }) }));
export {
  i as default
};
//# sourceMappingURL=DeleteIcon.es.js.map
